import script from "./WalletView.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletView.vue?vue&type=script&setup=true&lang=js"

import "./WalletView.vue?vue&type=style&index=0&id=4d3e13c2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d3e13c2"]])

export default __exports__